<template lang="pug">
  .contenedor-datos
    .title
      span.little Mis datos de seguridad y notificación
      span.icon.close(@click="$emit('close')")
        i.fa.fa-close
    loading(v-if="isLoading")
    template(v-else)
      section.body.flex(:class="{'flex-direction-column': isMobile}")
        .flex.flex-direction-column.flex-1
          .control
            p Ingresa tu nueva contraseña
            input.input(type="password", v-model="newPassword")
          .control
            p Ingresa nuevamente la contraseña
            input.input(type="password", v-model="repeatNewPassword")
        .control.flex-1
          p Email de notificaciones
          input.input(type="text", v-model="email")
        .control.flex-1
          p Ingrese su contraseña actual
          input.input(type="password", v-model="password", @keyup.enter="guardar")

      section.contenedor-guardar
        button.button.is-primary(@click="guardar" :class="{'is-loading': isSaving}")
          span.icon.is-small
            i.fa.fa-save.fa-fw.fa-lg
          span Guardar
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'datos_personales_seguridad_component',
  data () {
    return {
      newPassword       : '',
      repeatNewPassword : '',
      email             : '',
      password          : '',
      isMobile          : false,
      isSaving          : false,
      isLoading         : false
    }
  },
  created () {
    this.fetch()
    window.addEventListener('resize', this.updateIsMobile)
  },
  mounted () {
    this.updateIsMobile()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = window.innerWidth <= 650
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
      }
      apiGet(vm, '/personal/empleado/seguridad', obj, function (data) {
        vm.newPassword       = ''
        vm.repeatNewPassword = ''
        vm.email             = data.data.email
        vm.password          = ''
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar () {
      var vm = this
      vm.isSaving = true

      // Algunas validaciones
      if (!vm.password) {
        notify(vm, 'error', 'Debe ingresar su contraseña actual para hacer cambios en estos datos')
        vm.isSaving = false
        return
      }

      if (!vm.email) {
        notify(vm, 'error', 'Ingrese el email')
        vm.isSaving = false
        return
      }

      if (!vm.validateEmail(vm.email)) {
        notify(vm, 'error', 'Ingrese el email correcto')
        vm.isSaving = false
        return
      }

      var obj = {
        empleado : {
          newPassword       : vm.newPassword,
          repeatNewPassword : vm.repeatNewPassword,
          email             : vm.email,
          password          : vm.password
        }
      }

      apiPost(vm, '/personal/empleado/seguridad', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-transition
    >*
      transition: all 0.5s;

  .contenedor-datos
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  section
    .control
      margin 5px
    .title
      text-align left
      border-bottom 2px solid #565cde
      padding-bottom 10px
      font-size 20px !important

  .flex
    display flex
  .flex-1
    flex 1

  .opciones
    display flex
    .opcion
      cursor pointer
      width 50px
      margin 5px
      text-align center
      border 1px solid #565cde
      &.active
        background-color #565cde
        color white

  section
    margin-bottom 10px

  .contenedor-boton-agregar-hijo
    display flex
    justify-content center
    margin-top 10px

  .contenedor-hijos
    flex-direction column

  .button-quitar-hijo
    margin-top auto
    margin-bottom 10px
    background-color red

  i.fa.fa-close
    position: absolute;
    top: 6px;
    right: 6px;

</style>



// WEBPACK FOOTER //
// Component_Datos_Personales_Seguridad.vue?b833eefe